'use client'

import { PromoService } from '@/screens/promo-service'

const ServiceAboutUsPageContent = () => {
	return <PromoService />
}

export function ServiceAboutUsClient() {
	return <ServiceAboutUsPageContent />
}
